<template>
    <IndexBase @auth="onAuth($event)" action="IndexMD" controller="Approval"></IndexBase>

    <OverlayPanel ref="op" :showCloseIcon="true" :dismissable="true" :breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '450px'}">
        <InputText v-model="overlayText" @input="onEditRemarks" style="width:100%"/> 
    </OverlayPanel>

    <Dialog :header="$t('approval_confirmation')" v-model:visible="showApprovalConfirmationModal" :closeOnEscape="false" :closable="false" :modal="true" :breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '50vw'}">
        <div>
            <span v-if="confirmationStatus == 'APPROVED'">{{this.$t('message.approve_confirmation')}}</span>
            <span v-else-if="confirmationStatus == 'REJECTED'">{{this.$t('message.reject_confirmation')}}</span>
            
            <div v-if="!processed">
                <div v-for="doc in selectedDocuments" v-bind:key="doc.ref_no">
                    <div class="grid">
                        <div class="col-5">
                            {{doc.ref_no}}
                        </div>
                        <div class="col-6">
                            
                            <div class="p-fluid">
                                <InputText type="text" :placeholder="$t('notes')" class="p-inputtext-sm" v-model="doc.remarks"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div v-for="item in resultData" v-bind:key="item.ref_no">
                    <div class="grid">
                        <div class="col-5">
                            {{item.ref_no}}
                        </div>
                        <div class="col-6">
                            <div class="p-fluid">
                                <InputText type="text" class="p-inputtext-sm" :placeholder="$t('notes')" v-model="item.remarks" :disabled="true" />
                            </div>
                        </div>
                        <div class="col-1">
                            <div v-if="item.success">
                                <Tag v-if="confirmationStatus == $APPROVAL_STATUS.APPROVED" class="mr-2" :severity="'success'" :value="'Approved'"></Tag>
                                <Tag v-if="confirmationStatus == $APPROVAL_STATUS.REJECTED" class="mr-2" :severity="'danger'" :value="'Rejected'"></Tag>
                                <Tag v-if="confirmationStatus == $APPROVAL_STATUS.REVISED" class="mr-2" :severity="'success'" :value="'Revised'"></Tag>
                            </div>
                            <div v-else>
                                <Tag class="mr-2" severity="danger" :value="item.message"></Tag>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <template #footer>
            <div v-if="processed">
                <Button label="Close" @click="dismissConfirmation" />
            </div>
            <div v-else>
                <div v-if="processing" style="float:right!important">
                    <ProgressSpinner style="width:50px;height:50px"/>
                </div>
                <div v-else>
                    <div v-if="!processed">
                        <Button label="No" @click="dismissConfirmation" />
                        <Button label="Yes" autofocus @click="confirmApproval"/>
                    </div>
                    <div v-else>
                        <Button label="Close" icon="pi pi-times" class="p-button-text" @click="onClose"/>
                    </div>
                    
                </div>
            </div>
        </template>
    </Dialog>
    
    <Dialog header="Approval Details" v-model:visible="showApprovalDetails" :closeOnEscape="true" :closable="true" :modal="true" :breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '60vw'}" >
        <DataTable :loading="!approvalDetails" :value="approvalDetails ? approvalDetails : null" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table" :rowClass="setCurrentRow">
            <Column field="Username" :header="$t('username')" key="Username" style="width:10%">  
            </Column>
            <Column field="fullname" :header="$t('full_name')" key="Fullname" style="width:10%">  
            </Column>
            <Column field="Level" :header="$t('level')" key="Level" style="width:10%">  
            </Column>
            <Column field="Status" :header="$t('status')" key="Status">
            </Column>
            <Column field="Approval_By" :header="$t('approval_by')" key="Approval_By" style="width:15%">
            </Column>
            <Column field="Approval_Date" :header="$t('approval_date')" key="Approval_Date" style="width:15%">
                <template #body={data}>
                    {{$formatDateTime(data.Approval_Date)}}
                </template>
            </Column>
            <Column field="Info1" :header="$t('matrix')" key="Info1" style="width:10%">
            </Column>
        </DataTable>
    </Dialog>

    <Card>
        <template #title>
            <Toolbar>
                <template #left>
                    <div class="p-card-title">
                        {{$t('approval_master_data')}}
                        <Button icon="pi pi-refresh" class="p-button-rounded p-button-info p-button-outlined ml-2" @click="loadLazyData"/>
                    </div>
                </template>
                <template #right>
                    <Button class="pi-button p-button-success" :label="$t('approve')" v-if="selectedRow != null && selectedRow.length > 0" @click="processSelectedData($APPROVAL_STATUS.APPROVED)" />
                    <!-- <Button class="pi-button p-button-danger ml-2" :label="$t('reject')" v-if="selectedRow != null && selectedRow.length > 0" @click="processSelectedData($APPROVAL_STATUS.REJECTED)" /> -->
                    <Button class="pi-button p-button-warning ml-2 text-white" :label="$t('revisi')" v-if="selectedRow != null && selectedRow.length > 0" @click="processSelectedData($APPROVAL_STATUS.REVISED)" />
                </template>
            </Toolbar>
        </template>
        <template #content>
            <div class="p-fluid mb-3">
                <CustomSelectButton :disabled="true" :options="listWaiting" optionLabel="option" class="p-text-center" :setDefault="true"> 
                    <template #option="slotProps">
                        <div class="p-text-center" style="width:100%">
                            <Badge :value="slotProps.option" size="large" severity="warning"></Badge>
                        </div>
                    </template>
                </CustomSelectButton>

                <CustomSelectButton v-model="selectedStatus" :options="statusList" optionLabel="option" class="p-text-center" @change="onStatusChange" :setDefault="true"> 
                    <template #option="slotProps">
                        <div class="p-text-center" style="width:100%">
                            {{slotProps.option}} 
                            <!-- <Badge :value="totalApproval" severity="warning"></Badge> -->
                        </div>
                    </template>
                </CustomSelectButton>
            </div>

            <DataTable ref="dt" responsiveLayout="scroll" class="p-datatable-sm" filterDisplay="row" sortMode="multiple" removableSort
                       v-model:expandedRows="expandedRows"
                       stateStorage="local"
                       :stateKey="stateKey"
                       :value="dataModel" :loading="!dataModel || loading"
                       :paginator="true"
                       :rows="10"
                       :lazy="true"
                       v-model:first="this.start"
                       @rowExpand="onRowExpand"
                       @state-restore="onStateRestore($event)"
                       @state-save="onStateSave($event)"
                       @page="onPage($event)"
                       @sort="onSort($event)"
                       @filter="onFilter($event)"
                       @update:selection="onSelect($event)"
                       @row-dblclick="onRowDoubleClick"
                       v-model:filters="filters"
                       :totalRecords="totalRecords"
                       v-model:selection="selectedRow" selectionMode="multiple" dataKey="Id" :metaKeySelection="false"
                       :rowClass="rowClass" id="approvalid"
                    >
                    <!-- :rowClass="'p-disabled'" -->
                <Column :exportable="false" :sortable="false" headerStyle="width: 1rem">
                    <!-- :expander="true" -->
                    <template #header>
                        <!-- <Button v-if="canCreate" label="Create" icon="pi pi-plus" class="p-button-primary p-button-sm" @click="editor(this.$FORM_MODE_CREATE, 0)" /> -->
                    </template>
                    <template #filter>
                        <Button :label="$t('clear')" icon="pi pi-filter-slash" class="p-button-outlined p-button-primary p-button-sm" @click="clearFilter" :badge="filterBadge" badgeClass="p-badge-danger" />
                    </template>
                    <!-- <template #body="{data}">
                        <button class="p-row-toggler p-link ml-2" type="button" v-ripple @click="toggleRemarksPopup($event,data)" v-tooltip.right="{value: data.Remarks, disabled: !data.Remarks}">
                            <i class="pi pi-comment p-text-secondary" v-badge="Y" v-if="data.Remarks"></i>
                            <i class="pi pi-comment p-text-secondary" v-else></i>
                        </button>                        
                    </template> -->
                    <template #body="dataModel">
                        <Button icon="pi pi-search"
                        class="p-button-rounded mr-2 p-button-sm" style="pointer-events:visible;"
                        @click="goToDetail(dataModel)" />              
                    </template>
                    
                </Column>
             
                <!-- <Column expander /> -->

                <Column v-if="user || all" field="Employee_Number" :header="$t('emp_number')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText :placeholder="$t('emp_number')" type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column v-if="user || all" field="Full_Name" :header="$t('full_name')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText :placeholder="$t('full_name')" type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column v-if="user || all" field="Email" :header="$t('email')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText :placeholder="$t('email')" type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                 <Column v-if="user || all" field="User_Type" :header="$t('user_type')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText :placeholder="$t('user_type')" type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="Reason" :header="$t('reason')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText :placeholder="$t('Reason')" type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>


                <!-- <Column v-if="company || contractor || all" field="Code" :header="$t('code')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText :placeholder="$t('code')" type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column> -->
                
                <!-- <Column field="Status" :header="$t('status')" :sortable="true">

                    <template #filter="{filterModel,filterCallback}">
                        <InputText :placeholder="$t('status')" type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"/>
                    </template>
                </Column> -->






<!-- 
                <Column v-if="user || all" field="Job_Position" :header="$t('job_postion')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText :placeholder="$t('job_postion')" type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column> -->

                <!-- <Column v-if="user || all" field="Contact_Number" :header="$t('contact_number')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText :placeholder="$t('contact_number')" type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column> -->
<!-- 
                <Column v-if="user|| all" field="Company" :header="$t('company')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText :placeholder="$t('company')" type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>

                <Column v-if="user|| all" field="Company_Contractor" :header="$t('company_contractor')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText :placeholder="$t('company_contractor')" type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column> -->

                <!-- <Column v-if="company || contractor|| all" field="Company_Name" :header="$t('company_name')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText :placeholder="$t('company_name')" type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column> -->
<!-- 
                <Column v-if="contractor|| all" field="Adress" :header="$t('adress')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText :placeholder="$t('adress')" type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column> -->
<!-- 
                <Column v-if="contractor|| all" field="Service_Type" :header="$t('service_type')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText :placeholder="$t('service_type')" type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>

                <Column v-if="company|| all" field="Area" :header="$t('area')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText :placeholder="$t('area')" type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column> -->



                <Column field="Created_By" :header="$t('request_by')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText :placeholder="$t('request_by')" type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>

                <Column field="Created_Date" :header="$t('request_date')" :sortable="true">
                     <template #filter="{ filterModel, filterCallback }">
                        <DatePicker :placeholder="$t('request_date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999"
                            momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()" @date-select="filterCallback()"/>
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDateTime(data.Created_Date) }}
                    </template>
                </Column>

                <Column field="Last_Approval_By" :header="$t('last_approval_by')" :sortable="true">
                    <template #filter="{filterModel,filterCallback}">
                        <InputText :placeholder="$t('last_approval_by')" type="text" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>

                <Column field="Last_Approval_Date" :header="$t('last_approval_date')" :sortable="true">
                      <template #filter="{ filterModel, filterCallback }">
                        <DatePicker :placeholder="$t('last_approval_date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999"
                            momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()" @date-select="filterCallback()"/>
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDateTime(data.Last_Approval_Date) }}
                    </template>
                </Column>
                <!-- <template #expansion="slotProps">
                    <div class="orders-subtable">
                        <DataTable :value="slotProps" class="p-datatable-sm" responsiveLayout="scroll">
                            <Column style="width: 90px;" v-if="slotProps.data.Category == this.$CATEGORYMD.USER" field="Employee_Number" :header="$t('emp_number')"></Column>
                            <Column style="width: 90px;" v-if="slotProps.data.Category == this.$CATEGORYMD.USER" field="User_Type" :header="$t('user_type')"></Column>
                            <Column style="width: 90px;" v-if="slotProps.data.Category == this.$CATEGORYMD.USER" field="Full_Name" :header="$t('name')"></Column>
                            <Column style="width: 90px;" v-if="slotProps.data.Category == this.$CATEGORYMD.USER" field="Email" :header="$t('email')"></Column>
                            <Column style="width: 90px;" v-if="slotProps.data.Category == this.$CATEGORYMD.USER" field="User_Type" :header="$t('user_type')"></Column>
                            <Column style="width: 90px;" v-if="slotProps.data.Category == this.$CATEGORYMD.USER" field="Job_Position" :header="$t('job_position')"></Column>
                            <Column style="width: 90px;" v-if="slotProps.data.Category == this.$CATEGORYMD.USER" field="Contact_Number" :header="$t('contact_number')"></Column>

                            <Column style="width: 90px;" v-if="slotProps.data.Category == this.$CATEGORYMD.USER && slotProps.data.User_Type == this.$UserType.WILMAR" field="Company" :header="$t('company')"></Column>
                            <Column style="width: 90px;" v-if="slotProps.data.Category == this.$CATEGORYMD.USER && slotProps.data.User_Type == this.$UserType.CONTRACTOR" field="Company_Contractor" :header="$t('company_contractor')"></Column>
                            
                            <Column style="width: 90px;" v-if="slotProps.data.Category == this.$CATEGORYMD.COMPANY || slotProps.data.Category == this.$CATEGORYMD.CONTRACTOR" 
                                field="Code" :header="$t('code')"/>
                            <Column style="width: 90px;" v-if="slotProps.data.Category == this.$CATEGORYMD.COMPANY || slotProps.data.Category == this.$CATEGORYMD.CONTRACTOR" 
                                field="Company_Name" :header="$t('description')"/>
                            <Column style="width: 90px;" v-if="slotProps.data.Category == this.$CATEGORYMD.COMPANY " field="Area" :header="$t('area')"></Column>
                            <Column style="width: 90px;" v-if="slotProps.data.Category == this.$CATEGORYMD.CONTRACTOR " field="Adress" :header="$t('adress')"></Column>

                            <Column style="width: 90px;" v-if="slotProps.data.Category == this.$CATEGORYMD.CONTRACTOR " field="Service_Type" :header="$t('service_type')"></Column>

                            <Column style="width: 90px;" field="Reason" :header="$t('reason')"></Column>

                            <Column style="width: 90px;" field="Created_Date" :header="$t('created_date')">
                                <template #body="{data}">
                                    {{ this.$formatDateTime(data.Created_Date)}}
                                </template>
                            </Column>
                            <Column style="width: 90px;" field="Created_By" :header="$t('created_by')"></Column>
                        </DataTable>
                    </div>
                </template> -->
            </DataTable>
        </template>
    </Card>
</template>

<script>
    import IndexBase from '../Helper/IndexBase.vue'

    export default {
        name: "Approval",
        components: {
            'IndexBase': IndexBase,
        },
        data() {
            return {
                dataModel: null,
                loading: false,
                totalRecords: 0,
                start: 0,
                stateKey: 'pas-state-approvalMD-' + this.$store.getters.getUsername,
                role: this.$store.getters.getRole,
                isAdmin: this.$store.getters.getIsAdmin,
                isUser: this.$store.getters.getIsUser,
                sorts: null,
                lazyParams: {},
                filters: null,
                stateFilters: null,
                editorPath: "/Approval/Editor",
                approvalDetailsUrl: "approval/approval_details/",
                dataUrl: "approval/list",
                statusUrl: "approval/status",
                approveUrl: "approval/process",
                canCreate: false,
                canEdit: false,
                canDelete: false,
                canView: false,
                selectedRow: null,
                statusList: null,
                selectedStatus: null,
                expandedRows: [],
                createOrder: false,
                assignTransporter:false,
                createAppointment: false,
                category: "",
                selectedCategoryIndex:0,
                overlayData: null,
                overlayText:"",
                showApprovalConfirmationModal: false,
                confirmationStatus: "",
                processed: false,
                processing: false,
                resultData: [],
                showApprovalDetails: false,
                approvalDetails: [],
                pageSize: 10,
                totalApproval : 0,
                listTransaction : [],
                listWaiting : null,
                isreview : false,
            }
        },
        methods: {
            rowClass(data) {
                return [{ 'bg-yellow-500': data.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL },
                      
                        { 'disabled-column bg-red': data.Status == this.$APPROVAL_STATUS.REJECTED },
                        { 'disabled-column': (data.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL && data.Active == false) || (this.isreview && data.Username != this.$store.getters.getUsername)},
                        { 'disabled-column bg-orange-500': data.Status == this.$APPROVAL_STATUS.REVISED },
                    ];
            },
            onEditRemarks(){
                this.overlayData.Remarks = this.overlayText;
            },
            toggleRemarksPopup(event, data){
                this.overlayData = data;
                this.overlayText = data.Remarks;
                this.$refs.op.toggle(event);
            },
            onAuth(event) {
                this.canCreate = event.canCreate;
                this.canEdit = event.canEdit;
                this.canDelete = event.canDelete;
                this.canView = event.canView;
            },
            onPage(event) {
                this.start = event.first;
                this.pageSize = event.rows;
                this.loadLazyData();
            },
            onSort(event) {
                this.sorts = event.multiSortMeta;
                this.loadLazyData();
            },
            onFilter() {
                this.loadLazyData();
            }, 
            onSelect(event){
                this.selectedRow = event.data;
            },
            onRowExpand(event){
                this.expandedRows = [];
                this.expandedRows.push(event.data);
            },
            editor(mode, id) {
                this.$router.push({ path: this.editorPath, query: { mode: mode, id: id } });
            },
            loadLazyData() {
                this.selectedRow = null;

                this.lazyParams = {
                    start: this.start,
                    pageSize : this.pageSize,
                    sorts: this.dataSort,
                    filters: this.dataFilter,
                    category: this.selectedStatus,
                    module : this.$ApprovalMatrixModule.MD,
                    listtransacton : this.listTransaction
                };

                var self = this;

                if(!self.loading){
                    this.loading = true;

                    this.$axios.post(this.$API_URL + this.dataUrl, this.lazyParams)
                        .then((response) => {
                            if (response.data.success) {
                                self.dataModel = response.data.data.listdata;
                                self.totalRecords = response.data.totalRecords;
                                self.totalApproval =  response.data.totalApproval;
                                self.listWaiting =response.data.data.listWaiting;
                            }
                            else {
                                self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                            }

                            self.loading = false;
                        })
                        .catch(function (err) {
                            self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                            self.loading = false;
                        });
                }

               
            },
            setFilters() {
                this.filters = {};
                var exportable = this.$refs.dt.columns.filter(c => c.props.field);
                for (var i = 0; i < exportable.length; i++) {
                    var filterValue = "";
                    if(this.stateFilters){
                        var field = this.stateFilters[exportable[i].props.field];
                        if(field) filterValue = field.value;
                    }
                    this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
                }
            },
            onStateRestore(event) {
                this.start = event.first;
                this.stateFilters = event.filters;
                this.sorts = event.multiSortMeta;
                this.pageSize = event.rows;
                this.selectedCategoryIndex = event.selectedCategoryIndex ?? 0;
            },
            onStateSave(event){
                event.selectedCategoryIndex = this.selectedCategoryIndex;

            },
            onModalClose(){
                this.loadLazyData();
            },
            clearFilter(){
                this.filters = {};
                var exportable = this.$refs.dt.columns.filter(c => c.props.field);
                for (var i = 0; i < exportable.length; i++) {
                    var fieldName = exportable[i].props.field;
                    var filterValue = "";
                    if (fieldName.includes("Date")) {
                        filterValue = null;
                    }
                    this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
                }
                this.loadLazyData();
            },
            onStatusChange(event){
                this.selectedStatus = event.value;
                this.selectedCategoryIndex = event.index;
                this.$refs.dt.triggerSaveState();
                this.setFilters();
                this.$toast.removeAllGroups();
                this.loadLazyData();
            },
            processSelectedData(status){
                this.showApprovalConfirmationModal = true;
                this.confirmationStatus = status;
            },
            confirmApproval(){
                var self = this;

                var data = {
                    data: this.selectedDocuments,
                    status: this.confirmationStatus
                };
                self.processing = true;
                
                this.$axios.put(this.$API_URL + this.approveUrl, data)
                    .then((response) => {
                        self.processed = true;
                        self.processing = false;

                        if (response.data.success) {
                            self.resultData = response.data.data.data;

                            self.$router.push({ name: this.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: response.data.message, life: 120000} } );
                        }
                        else {
                            self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                        }
                    })
                    .catch(function (error) {
                        self.processed = false;
                        self.processing = false;

                        self.$toast.add({ severity: 'error', summary: "Error", detail: error, life: 120000});
                    });
            },
            dismissConfirmation(){
                this.processed = false;
                this.showApprovalConfirmationModal = false;
                this.loadLazyData();
            },
            onRowDoubleClick(event){
                var self = this;

                self.approvalDetails = [];
                var approvalDataId = event.data.Approval_Id;
                var dataId = event.data.Id;

                self.showApprovalDetails = true;

                this.$axios.get(this.$API_URL + this.approvalDetailsUrl + dataId + "/" + approvalDataId)
                    .then((response) => {
                        if (response.data.success) {
                            self.approvalDetails = response.data.data;
                            self.$router.push({ name: this.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: response.data.message, life: 120000} } );
                        }
                        else {
                            self.showApprovalDetails = false;
                            self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                        }
                    })
                    .catch(function (error) {
                        self.showApprovalDetails = false;

                        self.$toast.add({ severity: 'error', summary: "Error", detail: error, life: 120000});
                    });
            },
            setCurrentRow(data){
                return data.is_current ? "current-approval" : "";
            },
            goToDetail(event){
                //var index = event.index;
                var data = event.data;
                if(data.Category == this.$CATEGORYMD.USER){
                    let routeData = this.$router.resolve({name: 'UserEditor', query: {mode: this.$FORM_MODE_VIEW, id: data.User_Id}});
                    window.open(routeData.href, '_blank');
                }
                else if(data.Category == this.$CATEGORYMD.COMPANY){
                    let routeData = this.$router.resolve({name: 'CompanyEditor', query: {mode: this.$FORM_MODE_VIEW, id: data.Company_Id}});
                    window.open(routeData.href, '_blank');
                }
                else if(data.Category == this.$CATEGORYMD.CONTRACTOR){
                    let routeData = this.$router.resolve({name: 'ContractorEditor', query: {mode: this.$FORM_MODE_VIEW, id: data.Contractor_Id}});
                    window.open(routeData.href, '_blank');
                }
               
            }
        },
        mounted() {
            this.$emit('unblock-ui');
            this.setFilters();
            var self = this;
            var jobpostion = this.$store.getters.getJobPosition;
            //if(jobpostion.length > 0)
            self.isreview = this.$store.getters.getIsAdministrator && !this.$store.getters.getIsHaveRelease;
            
            this.$axios.get(this.$API_URL + this.statusUrl + '/' + this.$ApprovalMatrixModule.MD)
                .then((response) => {
                    if (response.data.success) {
                        self.statusList = response.data.data;
                        self.listTransaction =  Object.values(this.statusList);
                        var selectedStatusValue = Object.values(this.statusList)[this.selectedCategoryIndex];
                        if(selectedStatusValue == undefined){
                            self.selectedStatus = Object.values(this.statusList)[0];
                        }
                        else{
                            self.selectedStatus = selectedStatusValue;
                        }

                        self.loadLazyData();
                    }
                    else {
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                    }

                    self.loading = false;
                })
                .catch(function (err) {
                    self.$toast.add({ severity: 'error', summary: "Error", detail: err, life: 120000});
                    self.loading = false;
                });            
        },
        computed: {
            dataFilter() {
                var h = [];
                if (this.filters) {
                    for (const [key, value] of Object.entries(this.filters)) {
                        h.push({
                            field: key,
                            value: value.value,
                            matchMode: value.matchMode
                        });
                    }
                }
                return h;
            },
            dataSort() {
                var h = [];
                if (this.sorts) {
                    for (var x = 0; x < this.sorts.length; x++) {
                        h.push({
                            field: this.sorts[x].field,
                            order: this.sorts[x].order == 1 ? "ASC" : "DESC"
                        });
                    }
                }
                return h;
            },
            all(){
                return this.selectedCategoryIndex == 0;
            },
            user(){
                return this.selectedCategoryIndex == 1;
            },
            company(){
                return this.selectedCategoryIndex == 2;
            },
            contractor(){
                return this.selectedCategoryIndex == 3;
            },
            selectedDocuments(){
                var data = [];

                if(this.selectedRow == null) return data;
                for(var x = 0; x< this.selectedRow.length; x++){
                    var row = this.selectedRow[x];
                    var ref_no = "";
                    if(row.Category == this.$CATEGORYMD.USER)
                        ref_no = row.Employee_Number
                    else
                        ref_no = row.Code

                    var d = {
                        id: row.Id,
                        remarks: row.remarks,
                        ref_no: ref_no
                    };

                    data.push(d);
                }
                return data;
            },
            filterBadge(){
                var badgeNumber = 0;

                this.dataFilter.filter(function(item) {                    
                    if(item.value && item.field != "Status"){
                        badgeNumber++;
                    }
                });

                return badgeNumber;
            }
            
        },
    }
</script>

<style>
    .p-card .p-card-content{
        margin:0!important;
        padding: 0 !important;
    }

    #approvalid .bg-red{
        background-color:red;
    }

    #approvalid .disabled-column {
        opacity: 0.7;
        color: #000;
        pointer-events: none; /* This prevents interaction with the content of the column */
      }


      
</style>

<!-- .p-datatable .p-datatable-tbody > tr > td .p-row-toggler, .p-datatable .p-datatable-tbody > tr > td .p-row-editor-init, .p-datatable .p-datatable-tbody > tr > td .p-row-editor-save, .p-datatable .p-datatable-tbody > tr > td .p-row-editor-cancel{
    pointer-events: visible;
  } -->